import script from "./CategorySelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategorySelector.vue?vue&type=script&lang=ts&setup=true"

import "./CategorySelector.vue?vue&type=style&index=0&id=6b49634e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b49634e"]])

export default __exports__